exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sF1ZzAymrWsRheewPtcgJ {\n    border-radius: 24px 0px 0px 24px;\n}\n\n._3eDGXYEIVs9nQGXo5qlhKI {\n    border-radius: 0px 24px 24px 0px;\n}\n\n.ezlUPCuhCeTu_CJ9ZW61V {\n    border-radius: 24px;\n}\n", ""]);

// exports
exports.locals = {
	"image-left-side-border": "sF1ZzAymrWsRheewPtcgJ",
	"imageLeftSideBorder": "sF1ZzAymrWsRheewPtcgJ",
	"image-right-side-border": "_3eDGXYEIVs9nQGXo5qlhKI",
	"imageRightSideBorder": "_3eDGXYEIVs9nQGXo5qlhKI",
	"image-default-border": "ezlUPCuhCeTu_CJ9ZW61V",
	"imageDefaultBorder": "ezlUPCuhCeTu_CJ9ZW61V"
};